import { type DatabaseExternalFile } from '@/lib/types';
import dummyFunction from '@/lib/utils/dummyFunction';
import { createContext } from 'react';

const ExternalFilesContext = createContext<{
  externalFiles: DatabaseExternalFile[];
  externalFilesExternalIds: string[];
  externalFilesEndpoint: string;
  addExternalFileToLocalState: (externalFile: DatabaseExternalFile) => void;
  removeExternalFileFromLocalState: (
    externalFile: DatabaseExternalFile,
  ) => void;
}>({
  externalFiles: [],
  externalFilesExternalIds: [],
  externalFilesEndpoint: '',
  addExternalFileToLocalState: dummyFunction,
  removeExternalFileFromLocalState: dummyFunction,
});

export default ExternalFilesContext;
